import { z } from "zod";
import { articleCategorySchema } from "./article-category";

export const articleLogSchema = z.object({
	id: z.string().optional(),
	status: z.string().optional(),
	remarks: z.string().optional(),
	created_at: z.string().optional(),
});

export const articleSchema = z.object({
	id: z.string().optional(),
	title: z.string(),
	body: z.string(),
	author: z.string().optional(),
	created_by: z.string().optional(),
	published_at: z.string().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
	status: z.string().optional(),
	remarks: z.string().optional(),
	categories: z.array(articleCategorySchema).optional(),
	coverphoto: z.instanceof(File).optional(),
	caption: z.string().optional(),
	latest_log: z
		.object({
			article_id: z.string().optional(),
			causer_id: z.string().optional(),
			status: z.string().optional(),
			remarks: z.string().optional(),
		})
		.optional(),
	logs: z.array(articleLogSchema).optional(),
});

const categorySelectSchema = z.object({
  label: z.string(),
  value: z.string(),
})

export const articleFormSchema = z.object({
	id: z.string().optional().nullable(),
	title: z
		.string()
		.min(2, {
			message: "Title must be at least 2 characters.",
		})
		.max(200, {
			message: "Title must not be longer than 200 characters.",
		}),
	body: z.string().min(2, {
		message: "Body must be at least 2 characters.",
	}),
	status: z.string(),
	// categories: z.unknown(),
	categories: z.array(categorySelectSchema).min(1, {
		message: "Select at least 1 (one) Category",
	}),
	coverphoto: z.instanceof(File).optional(),
	caption: z.string().optional(),
	remarks: z.string().optional(),
	author: z.string().optional(),
	created_at: z.string().optional(),
	// status: z.enum(["Pending", "Draft", "Rejected", ""]),
});

export const uploadTiptapFormSchema = z.object({
	id: z.string().optional(),
	images: z.any(),
});

export type Article = z.infer<typeof articleSchema>;
export type ArticleFormSchema = z.infer<typeof articleFormSchema>;
export type UploadTiptapFormSchema = z.infer<typeof uploadTiptapFormSchema>;
